import React, { FunctionComponent, ReactNode, useMemo } from "react";
import CustomizationContext from "../../contexts/CustomizationContext";
import useCustomizationReducer from "../../hooks/useCustomizationReducer";
import { CustomizationState, InitialCustomizationState, Panel } from "../../states/customization";
import { Configuration } from "../../types/customization/configuration";

interface Props {
  children: ReactNode;
  configuration?: Configuration;
  initialState: InitialCustomizationState;
}

const CustomizationStateProvider: FunctionComponent<Props> = ({
  children,
  configuration,
  initialState,
}) => {
  const initialSelection = initialState.content.selectionPhotos;

  const completeInitialState: CustomizationState = {
    notifications: [],
    selection: {
      photos: initialSelection,
    },
    stash: { selection: [] },
    ui: {
      gallery: {
        opened: initialSelection.length === 0,
      },
      pagesConfigMapping: [],
      panel: {
        current: Panel.CLOSED,
      },
      prefilledTextsEdited: [],
    },
    undoRedo: {
      lastUndoKey: undefined,
      redoStack: [],
      undoStack: [],
    },

    track: () => Promise.resolve(),

    ...initialState,
  };

  const [state, dispatch] = useCustomizationReducer(completeInitialState);

  const context = useMemo(
    () => ({
      ...state,
      configuration,
      dispatch,
    }),
    [configuration, dispatch, state]
  );

  return <CustomizationContext.Provider value={context}>{children}</CustomizationContext.Provider>;
};

export default CustomizationStateProvider;
